import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface ServerStatusCardProps {
  title: string;
  value: string | null | undefined;
  icon: LucideIcon;
  statusColor?: string;
  subtitle?: string | null;
}

const ServerStatusCard = ({ title, value, icon: Icon, statusColor, subtitle }: ServerStatusCardProps) => {
  const displayValue = value || "N/A";
  
  return (
    <Card className="bg-black/50 backdrop-blur-sm border-primary/20">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Icon className="h-4 w-4" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className={`text-2xl font-bold ${statusColor || ''}`}>{displayValue}</p>
        {subtitle && (
          <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default ServerStatusCard;
